<template>
  <div class="wrapper">
    <!-- 理事会 -->
    <b-container>
      <layoutimg :cols="6" :md="4" :dataList="dataList"></layoutimg>
    </b-container>
  </div>
</template>
<script>
  import layoutimg from "@/forumcomponents/aboutList";
  export default {
    components: {
      layoutimg
    },
    data() {
      return {
        type: 2, //理事会
        dataList: [],
        childrenType: 3, //委员
        introInfo: {},
      };
    },
    created() {
    //   this.getAboutIntroInfo();
    //   this.getAboutList();
    },
      watch: {
     $route: {
        handler(to) {
          this.getAboutList(to.query.type,to.query.childrenType)
        },
        immediate: true,
        deep: true
      },
  },
    methods: {
   
      getAboutList(type,childrenType) {
        this.$forumApi
          .aboutList({
           type: type,
            childrenType:childrenType,
          })
          .then((res) => {
            if (res.code == 200) {
                 console.log('aboutList',res.data);
               this.dataList = res.data.map(item => {
                 var rank = [];
                if (item.introduce != null) {
                  let intro = JSON.parse(item.introduce);
                  intro.forEach((item) => {
                    rank.push(item.date);
                  });
                }
                return {
                  title: item.name,
                  titleImg: item.sysFilePhotoIdUrl,
                  rank: rank,
                  id: item.id,
                }
              })
            }
          });
      },
    },
  };
</script>
<style lang="scss" scoped>

.wrapper{
    margin-top:2.5rem;
}


  .left {
    flex: 0.25;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  p {
    margin-bottom: 0;
  }


  @media (max-width: 768px) {
    .intro {
      display: block;
    }

    .about {
      flex: 2;
      font-size: 1px;
      line-height: 1.8rem;
      padding: 1rem 2rem;
      color: #4a4a4a;
    }

    .intro {
      background: #f5f5f5;
      margin: 2rem 0rem;
      padding: 2rem 0rem 1rem 0rem;
    }

    .left {
      flex: 0.25;
      display: flex;
      flex-direction: column;
      align-items: start;
    }

    .bname {
      font-size: 1.2rem;
      padding: 0.5rem 8px 0px 2.5rem;
    }

    .sname {
      font-size: 0.2rem;
      color: #999;
      text-align: center;
      padding: 1rem 1rem 1rem 2.3rem;
    }

  }
</style>